import React, { useCallback, useState } from 'react'
import cx from 'classnames'
import { Helmet } from 'react-helmet'
import { Layout, LayoutBody, LayoutContent, LayoutProvider } from '../../../views/components'
import AdminAgencyAccessContent from './AdminAgencyAccessContent'
import GrantAccessPanel from './GrantAccessPanel/GrantAccessPanel'
import { TAdminUserLookup } from '../../api/user/types'
import styles from './AdminAgencyAccessPage.module.scss'

// Same drawer arrangement as AdminBillingPage: local state rather than the
// LayoutProvider secondary panel, which is left-anchored.
const AdminAgencyAccessPage = () => {
  const [grantFor, setGrantFor] = useState<TAdminUserLookup | null>(null)

  const closePanel = useCallback(() => setGrantFor(null), [])

  return (
    <div className={cx(styles.root, { [styles['with-panel']]: !!grantFor })}>
      <LayoutProvider
        stateKey="adminAgencyAccess"
        initialProps={{
          sidebar: { open: false, width: 0 },
          primaryPanel: { open: false, width: 0 },
          secondaryPanel: { open: false, width: 0 },
        }}
      >
        <Helmet>
          <title>reOS | Users</title>
        </Helmet>
        <Layout>
          <LayoutBody>
            <LayoutContent>
              <AdminAgencyAccessContent onGrantAccess={setGrantFor} />
            </LayoutContent>
          </LayoutBody>
        </Layout>
        {grantFor && <GrantAccessPanel user={grantFor} onClose={closePanel} />}
      </LayoutProvider>
    </div>
  )
}

export default AdminAgencyAccessPage
